module.exports = __webpack_public_path__ + "img/desc2.1111018a.png";